import { createSessionJsonStore, createSessionStore } from "@airange/shared/session";
import type { UserSession } from "@airange/shared/auth";

const SSO_NO_ACCESS_SNAPSHOT_KEY = "airange.edu.admin.sso_no_access_snapshot";

const sessionStore = createSessionStore<UserSession>({
  accessTokenKey: "airange.edu.admin.access_token",
  userKey: "airange.edu.admin.user",
});

export const { getAccessToken, getStoredUser, setSession, setAccessToken, setStoredUser } = sessionStore;

export type EduAdminSsoNoAccessSnapshot = {
  user: UserSession;
};

const ssoNoAccessSnapshotStore = createSessionJsonStore<EduAdminSsoNoAccessSnapshot>({
  key: SSO_NO_ACCESS_SNAPSHOT_KEY,
});

export function getStoredSsoNoAccessSnapshot(): EduAdminSsoNoAccessSnapshot | null {
  return ssoNoAccessSnapshotStore.get();
}

export function setStoredSsoNoAccessSnapshot(snapshot: EduAdminSsoNoAccessSnapshot | null | undefined) {
  ssoNoAccessSnapshotStore.set(snapshot);
}

export function consumeStoredSsoNoAccessSnapshot(): EduAdminSsoNoAccessSnapshot | null {
  return ssoNoAccessSnapshotStore.consume();
}

export function clearSession() {
  sessionStore.clearSession();
  ssoNoAccessSnapshotStore.clear();
}
